import { Component, Inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

interface Data {
  containerNo: string | null;
  openCustomMap: boolean;
  customMapUrl: string;
}

@Component({
  selector: 'app-live-tracking',
  standalone: true,
  templateUrl: './live-tracking.component.html',
  styleUrl: './live-tracking.component.scss'
})
export class LiveTrackingComponent {
  url: SafeResourceUrl | null = null;

  constructor(
    private dom: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: Data
  ) {}

  ngOnInit() {
    const url = this.data.openCustomMap && !!this.data.customMapUrl ? this.data.customMapUrl : `void(0)`;
    this.url = this.dom.bypassSecurityTrustResourceUrl(url);
  }
}
